<template>
    <div v-if="isConnected" class="compass-card mb-4" style="background: linear-gradient(135deg, rgba(34, 197, 94, 0.05), rgba(139, 92, 246, 0.05));">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0" style="font-weight: 600;">Your Portfolio</h5>
            <a href="/app/portfolio" class="compass-btn compass-btn--sm compass-btn--outline">View Full Portfolio &rarr;</a>
        </div>

        <div v-if="loading" class="text-center py-3">
            <span style="color: #9ca3af;">Loading positions...</span>
        </div>

        <div v-else-if="hasPositions" class="row">
            <div class="col-6 col-md-3 mb-2">
                <div class="stat-label">Total Value</div>
                <div class="stat-value price-display">${{ formatCompact(totalValue) }}</div>
            </div>
            <div v-for="(items, category) in positionsByCategory" :key="category" class="col-6 col-md-3 mb-2">
                <div class="stat-label text-capitalize">{{ category }}</div>
                <div class="stat-value font-mono-num">{{ items.length }} position{{ items.length !== 1 ? 's' : '' }}</div>
            </div>
        </div>

        <div v-else class="text-center py-2" style="color: #9ca3af;">
            <p class="mb-2">No DeFi positions found.</p>
            <a href="/app/stake" class="compass-btn compass-btn--sm compass-btn--primary">Start by Staking SOL</a>
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue';
import { useWalletPositions } from '../composables/useWalletPositions';

export default {
    name: 'DefiHome',
    setup() {
        const { fetchPositions, positions, totalValue, hasPositions, positionsByCategory, loading } = useWalletPositions();

        const isConnected = computed(() => {
            return !!window.wallet?.publicKey?.value;
        });

        function formatCompact(value) {
            if (!value) return '0';
            if (value >= 1000000) return (value / 1000000).toFixed(1) + 'M';
            if (value >= 1000) return (value / 1000).toFixed(1) + 'K';
            return value.toFixed(2);
        }

        onMounted(() => {
            if (isConnected.value) {
                fetchPositions();
            }
        });

        // Re-fetch when wallet connects
        watch(isConnected, (connected) => {
            if (connected) fetchPositions();
        });

        return {
            isConnected,
            loading,
            hasPositions,
            totalValue,
            positionsByCategory,
            formatCompact,
        };
    },
};
</script>
